import ListItemText from '@mui/material/ListItemText';
import { styled } from '@classify/react-core-components/styles';

const StyledListItemText = styled(ListItemText)(({ theme: { spacing } }) => ({
  flexGrow: 0,
  paddingRight: spacing(1),
}));

export default StyledListItemText;
